<template>
  <div>
    <van-overlay :show="showShare" z-index="1000">
      <div class="wrapper">
        <div class="block">
          <div style="display: flex; justify-content: flex-end">
            <van-icon name="close" size="20" @click="showShare = false" style="margin: 5px" />
          </div>
          <div style="margin-left: 40px; display: flex">
            <van-checkbox style="margin: 5px" v-model="AnonymousShare">加密分享</van-checkbox>
            <van-checkbox style="margin: 5px 5px 5px 10px" v-model="EncryptionShare">匿名分享</van-checkbox>
          </div>
          <div style="height: 200px; width: 200px; margin: 0 auto">
            <vue-qr :text="BarCodeContent" :size="200" :logoSrc="barcodelogoSrc"></vue-qr>
          </div>
          <div style="text-align: center; margin-bottom: 3px" v-if="AnonymousShare">
            <span>安全码:</span>
            <span style="color: red; font-weight: bold"> {{ SecurityCode }}</span>
          </div>
          <div style="text-align: center; margin-bottom: 3px">
            <span>有效期截止:</span>
            <span style="color: red; font-weight: bold"> {{ validityDate }}</span>
          </div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import VueQr from 'vue-qr'
import { EncryptAES } from '../../utils/stringUtils'
export default {
  name: 'Share',
  components: {
    VueQr,
  },
  data() {
    return {
      BarCodeDefaultContent: '',
      showShare: false,
      barcodelogoSrc: require('../../assets/logo_icon.png'),
      BarCodeContent: '',
      AnonymousShare: false,
      EncryptionShare: false,
      SecurityCode: '',
      ReportID: '',
      validityDate:''
    }
  },
  methods: {
    handleOverlayClick() {
      this.showShare = false
    },
    saveShare() {},
  },
  mounted() {
    this.showShare = false
    let localtionUrl = 'http://' + window.location.host
    // let localtionUrl=window.location.href
    // if(window.location.href.indexOf('?')>-1){
    //     localtionUrl=window.location.href.substring(0,window.location.href.indexOf('?'))
    // }
    this.validityDate=this.moment().add(1, 'days').format('YYYY-MM-DD HH:mm:ss')
    this.BarCodeDefaultContent = `${localtionUrl}/index.html#/login?isShare=${EncryptAES('1')}&dateTime=${EncryptAES(
      this.moment().add(1, 'days').format('YYYYMMDDHHmmss')
    )}`
  },
  watch: {
    showShare(value) {
      this.AnonymousShare = false
      this.EncryptionShare = false
      if (value) {
        this.BarCodeContent = `${this.BarCodeDefaultContent}&id=${this.ReportID}&securityCode=${EncryptAES(
          this.SecurityCode
        )}`
      }
      // console.log(this.BarCodeContent)
    },
    //加密分享
    AnonymousShare(value) {
      this.BarCodeContent = `${this.BarCodeDefaultContent}${
        value ? '' : '&securityCode=' + EncryptAES(this.SecurityCode)
      }${this.EncryptionShare ? '&isEncryption=' + EncryptAES('1') : ''}&id=${this.ReportID}`
      console.log(this.BarCodeContent)
    },
    //匿名分享
    EncryptionShare(value) {
      this.BarCodeContent = `${this.BarCodeDefaultContent}&${
        this.AnonymousShare ? '' : 'securityCode=' + EncryptAES(this.SecurityCode)
      }&${value ? 'isEncryption=' + EncryptAES('1') : ''}&id=${this.ReportID}`
      console.log(this.BarCodeContent)
      this.$emit('EncryptionValueChanged', value)
    },
  },
}
</script>

<style lang="less" scoped>
.wrapper {
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 280px;
  height: 320px;
  border-radius: 10px;
  background-color: #fff;
}
</style>